import PropTypes from 'prop-types'
import React from 'react'

import phoneNumberPrefixes from '../../../utils/phone-number-prefixes.json'
import CustomSelect from '../../CustomSelect'
import Input from '..'
import InputHint from '../InputHint'

const MessageIcon = () => (
  <svg
    height="40"
    viewBox="0 0 28 40"
    width="28"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <g>
          <path
            d="M21.76 27.401c.18.014.351.021.514.021.058 0 2.85-.001 2.905-.003 2.116-.069 2.679-1.294 2.762-2.398v-8.729c.043-1.25-1.296-2.497-2.513-2.382h-12.53c-.323 0-.585.262-.585.586 0 .323.262.585.586.585h12.537c.582-.097 1.374.604 1.333 1.225v8.687c-.066.672-.371 1.332-2.01 1.251-.056-.003-2.85-.006-2.91-.011-.322-.026-.604.217-.628.54-.025.322.216.604.54.628zM11.024 13.91H9.192c-1.381 0-2.505 1.068-2.505 2.382l.01 12.104c-.039 1.164 1.397 1.81 2.277 1.085l2.088-1.717c.299-.225.608-.362.986-.36h7.882c.324 0 .586-.263.586-.587 0-.323-.262-.586-.586-.586h-7.882c-.646-.001-1.218.23-1.724.622l-2.078 1.708c-.164.116-.383.047-.377-.166l-.01-12.103c0-.668.598-1.21 1.333-1.21h1.832c.323 0 .586-.263.586-.586 0-.324-.263-.586-.586-.586z"
            fill="#FFBA00"
            transform="translate(-408 -651) translate(408 651)"
          />
          <path
            d="M24.697 21.849c0-.97-.789-1.758-1.758-1.758-.97 0-1.758.789-1.758 1.758s.789 1.758 1.758 1.758c.97 0 1.758-.789 1.758-1.758zm-2.344 0c0-.323.263-.586.586-.586.323 0 .586.263.586.586 0 .323-.263.586-.586.586-.323 0-.586-.263-.586-.586zM20.01 21.849c0-.97-.79-1.758-1.758-1.758-.97 0-1.758.789-1.758 1.758s.788 1.758 1.758 1.758c.969 0 1.757-.789 1.757-1.758zm-2.344 0c0-.323.263-.586.586-.586.323 0 .586.263.586.586 0 .323-.263.586-.586.586-.323 0-.586-.263-.586-.586zM11.806 21.849c0 .969.789 1.758 1.758 1.758.97 0 1.758-.789 1.758-1.758 0-.97-.789-1.758-1.758-1.758-.97 0-1.758.789-1.758 1.758zm1.758-.586c.323 0 .586.263.586.586 0 .323-.263.586-.586.586-.323 0-.586-.263-.586-.586 0-.323.263-.586.586-.586z"
            fill="#FFBA00"
            transform="translate(-408 -651) translate(408 651)"
          />
          <path
            d="M24.406 12.798c.324 0 .586-.262.586-.586V3.457c0-1.906-1.543-3.457-3.44-3.457H3.448C1.551 0 .008 1.55.008 3.457v33.086C.008 38.449 1.551 40 3.448 40h18.105c1.896 0 3.439-1.55 3.439-3.457V29.16c0-.324-.262-.586-.586-.586-.324 0-.586.262-.586.586v2.573H1.18V5.538h17.037c.324 0 .586-.262.586-.586 0-.323-.262-.586-.586-.586H1.18v-.909c0-1.26 1.017-2.285 2.267-2.285h18.106c1.25 0 2.267 1.025 2.267 2.285v.91h-2.89c-.325 0-.587.262-.587.585 0 .324.262.586.586.586h2.891v6.674c0 .324.262.586.586.586zm-.586 20.107v3.638c0 1.26-1.017 2.285-2.267 2.285H3.447c-1.25 0-2.267-1.025-2.267-2.285v-3.638h22.64z"
            fill="#444C56"
            transform="translate(-408 -651) translate(408 651)"
          />
          <path
            d="M12.48 37.624c.969 0 1.757-.788 1.757-1.758 0-.969-.788-1.757-1.757-1.757-.969 0-1.757.788-1.757 1.757 0 .97.788 1.758 1.757 1.758zm0-2.343c.323 0 .585.262.585.585 0 .324-.262.586-.585.586-.322 0-.585-.262-.585-.586 0-.323.263-.585.585-.585zM10.533 2.066c-.324 0-.586.262-.586.586 0 .324.262.586.586.586h3.934c.324 0 .586-.262.586-.586 0-.324-.262-.586-.586-.586h-3.934zM18.143 2.326c-.19-.303-.654-.347-.901-.089-.226.22-.228.61 0 .83.219.225.61.227.829 0 .194-.192.227-.516.072-.74z"
            fill="#444C56"
            transform="translate(-408 -651) translate(408 651)"
          />
        </g>
      </g>
    </g>
  </svg>
)

class PhoneInput extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      phonePrefix: '+39',
    }
    this.handleInput = this.handleInput.bind(this)
    this.handleSelectPrefix = this.handleSelectPrefix.bind(this)
  }

  componentDidMount() {
    this.handleSelectPrefix({ value: this.state.phonePrefix }, true)
  }

  getPhoneValue() {
    return this.props.value
      ? this.props.value.replace(this.state.phonePrefix, '')
      : null
  }

  handleInput(event) {
    /**
     * Per essere retrocompatibile
     * alla prop passo un oggetto con la stessa
     * struttura di un SyntheticEvent
     * */
    this.props.onChange({
      target: {
        name: 'phone',
        value:
          event.target.value === ''
            ? ''
            : `${this.state.phonePrefix}${event.target.value.replace(
                /\s/g,
                ''
              )}`,
      },
    })
  }

  handleSelectPrefix(prefix, isInit = false) {
    const phone = this.props.value || ''
    const cleanPhone = phone.replace(this.state.phonePrefix, '') // rimuove il prefisso per poi aggiungere quello nuovo

    this.setState(
      {
        phonePrefix: prefix.value,
      },
      () => {
        if (!isInit) {
          this.handleInput({ target: { value: cleanPhone } })
        }
      }
    )
  }

  render() {
    const phoneValue = this.getPhoneValue()

    return (
      <div>
        <CustomSelect
          items={phoneNumberPrefixes.countries}
          onSelect={this.handleSelectPrefix}
          renderItem={item => `${item.name} ${item.value}`}
          style={{ float: 'left', width: '20%' }}
          value={this.state.phonePrefix}
        />

        <div style={{ float: 'left', paddingLeft: 10, width: '80%' }}>
          <Input
            classes={`form-input big ${this.props.className}`}
            dataCy={this.props.dataCy}
            defaultValue={phoneValue}
            label={this.props.label}
            name={this.props.name}
            placeholder={this.props.placeholder}
            type={'tel'}
            update={this.handleInput}
          />
          {this.props.hasHint ? (
            <div className="phone-hint">
              <InputHint content={`Verifica che il numero sia corretto`} />
            </div>
          ) : null}
        </div>

        {this.props.hasHint ? (
          <div className="row">
            <div
              style={{
                display: 'inline-block',
                width: '15%',
                textAlign: 'center',
              }}
            >
              <MessageIcon />
            </div>

            <p
              className="guide-tips-label"
              style={{
                display: 'inline-block',
                width: '85%',
                color: '#444c56',
              }}
            >
              Durante la compilazione riceverai a questo numero un SMS con il
              codice di sicurezza che ti permetterà di procedere alla richiesta
              di noleggio
            </p>
          </div>
        ) : null}
      </div>
    )
  }
}

PhoneInput.defaultProps = {
  label: 'Telefono cellulare',
  dataCy: '',
}
PhoneInput.propTypes = {
  label: PropTypes.string,
  dataCy: PropTypes.string,
}

export default PhoneInput
